import React from 'react';
import { Flex, Spinner } from '@applyboard/crystal-ui';
import { globalStyles } from "../../globalStyles";
import { PageWrapper } from "../PageWrapper";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var LoadingPage = function LoadingPage() {
  return _jsx(PageWrapper, {
    children: _jsxs("div", {
      role: "progressbar",
      "aria-label": "loading scholarship page",
      children: [_jsx("style", {
        children: globalStyles
      }), _jsx(Flex, {
        justify: "center",
        align: "center",
        children: _jsx(Spinner, {
          size: "xl"
        })
      })]
    })
  });
};